import styles from './NewsAsideListControl.module.scss';
import { NavLink, useLocation } from 'react-router-dom';
import NewsAsideItemControl from '../NewsAsideItemControl/NewsAsideItemControl';
import NewsYearFilter from '../NewsYearFilter/NewsYearFilter';
import Stickynode from 'react-stickynode';

const NewsAsideListControl = ({ type, prev, next, currentId, logoPosition }) => {
  const { pathname } = useLocation();

  const renderContent = () => (
    <div className={styles.link}>
      <NavLink
        to={'/news/events'}
        className={({ isActive }) =>
          isActive ? `${styles.pressed} ${styles.inner_link} ${styles.events}` : `${styles.inner_link} ${styles.events}`
        }>
        События
      </NavLink>
      {pathname && pathname.includes('events') && (
        <NewsAsideItemControl type={type} prev={prev} next={next} currentId={currentId} />
      )}

      {pathname && pathname.includes('media') && (
        <NewsAsideItemControl type={type} prev={prev} next={next} currentId={currentId} />
      )}
      <NavLink
        to={'/news/media'}
        className={({ isActive }) =>
          isActive ? `${styles.pressed} ${styles.media} ${styles.inner_link}` : `${styles.inner_link} ${styles.media}`
        }>
        Медиа
      </NavLink>

      {(pathname === '/news/events' || pathname === '/news/media') && (
        <NewsYearFilter data={pathname.replace('/news/', '')} />
      )}
    </div>
  );

  return logoPosition === 'fixed' ? <Stickynode top={280}>{renderContent()}</Stickynode> : renderContent();
};

export default NewsAsideListControl;
